

<template>
  <div class="admin-area">
    <div class="text-center">
      <v-container>
        <v-row
          class="text-center"
          align-content="center"
          align="center"
          justify="center"
          >
          
          <v-col
            justify="center"
            class="text-center"
            xs="12"
            sm="12"
            md="12"
            lg="12"
            xl="8"
          >
          <v-card min-height="100vh">
          <v-card-text>
            <v-row
              class="text-center"
              align-content="center"
              align="center"
              justify="center"
              ><v-col
                justify="center"
                class="text-center"
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
              >
                <v-sheet elevation="2" color="black" dark
                  ><p class="text-h4">APD Admin Area</p></v-sheet
                >
                <v-sheet elevation="2" color="rgb(255, 0, 0, 0)"
                  ><v-tabs
                    v-model="tab"
                    background-color="transparent"
                    color="basil"
                    center-active
                    grow
                  >
                    <v-tab
                      v-for="item in breadcrumbs"
                      :key="item.text"
                      :to="item.to"
                    >
                      {{ item.text }}
                    </v-tab>
                  </v-tabs></v-sheet
                >
              </v-col></v-row
            >
            <v-row align-content="center" justify="center">
              <v-col xs="12" sm="12" md="12" lg="12" xl="12">
                <router-view :key="$route.path"> </router-view>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
          
          </v-col
        ></v-row>
        
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      breadcrumbs: [
        {
          text: "Gérer Pollen Photos",
          disabled: false,
          to: { name: "AdminPhotos" },
        },
        {
          text: "Gérer Dictionnaire de Taxons",
          disabled: false,
          to: { name: "AdminTaxonDict" },
        },
        {
          text: "Gérer taxons non enregistrés",
          disabled: false,
          to: { name: "UnregisteredTaxons" },
        },
        {
          text: "Gérer Pollens Fossiles",
          disabled: false,
          to: { name: "AdminFossil" },
        },
        {
          text: "Gérer Pollens Modernes",
          disabled: false,
          to: { name: "AdminModerne" },
        },
      ],
    };
  },
  methods: {
    showAlert: () => {
      alert("test");
    },
  },
};
</script>